"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = exports.SkeletonStateType = exports.ColliderItemType = void 0;
const AnimationTrack_1 = require("./AnimationTrack");
const Bone_1 = require("./Bone");
const TrackMixin_1 = require("./Mixins/TrackMixin");
var ColliderItemType;
(function (ColliderItemType) {
    ColliderItemType[ColliderItemType["FREE_COLLIDER"] = 0] = "FREE_COLLIDER";
    ColliderItemType[ColliderItemType["BONE_COLLIDER"] = 1] = "BONE_COLLIDER";
    ColliderItemType[ColliderItemType["SLOT_BONE_COLLIDER"] = 2] = "SLOT_BONE_COLLIDER";
})(ColliderItemType = exports.ColliderItemType || (exports.ColliderItemType = {}));
var SkeletonStateType;
(function (SkeletonStateType) {
    SkeletonStateType[SkeletonStateType["BASE_SETUP"] = 0] = "BASE_SETUP";
    SkeletonStateType[SkeletonStateType["ATTACHMENT_SETUP"] = 1] = "ATTACHMENT_SETUP";
    SkeletonStateType[SkeletonStateType["ATTACHMENT_SLOT_SETUP"] = 2] = "ATTACHMENT_SLOT_SETUP";
    SkeletonStateType[SkeletonStateType["PASSIVE_ANIMATION"] = 3] = "PASSIVE_ANIMATION";
    SkeletonStateType[SkeletonStateType["MAIN_ANIMATION"] = 4] = "MAIN_ANIMATION";
})(SkeletonStateType = exports.SkeletonStateType || (exports.SkeletonStateType = {}));
class Skeleton extends PIXI.Container {
    constructor(baseSkeletonData, atlasLoader, activeSlotTextures, startingDirection) {
        super();
        this.nonSlotColliderLookup = {};
        this.action = '';
        this.stopped = true;
        this.childTracksImplicitlyPlayingCurrentAnimation = [];
        this.slotsByBone = {};
        this.attachmentTracks = [];
        this.attachmentSlots = {};
        this.attachments = {};
        this.baseTrack = null;
        this.bones = {};
        this.allActiveColliders = {};
        this.colliderUpdates = [];
        this.allSlotColliderLookup = {};
        //  readonly cachedBoneCalculations: {[attachmentId: number]: }
        this.activeSlotTextures = {};
        TrackMixin_1.TrackMixin.ApplyMixin(this);
        this.activeSlotTextures = activeSlotTextures || {};
        this._direction = startingDirection ? startingDirection : baseSkeletonData.directions[0];
        this.skins = {};
        this.bones = {};
        // initialize the base skeleton bones
        /*
        if (baseSkeletonData.boneIds) {
            for (let i = 0; i < baseSkeletonData.boneIds.length; i++) {
                const id = baseSkeletonData.boneIds[i]
                this.bones[id] = new Bone(id, this);
                this.addChild(this.bones[id]);
            }
        }*/
        this.data = baseSkeletonData;
        this.atlasLoader = atlasLoader;
        this.animationLookup = baseSkeletonData.animations;
        this.baseTrack = new AnimationTrack_1.AnimationTrack(this, 0, this.activeSlotTextures, this.bones, this.atlasLoader.slotIdToColliderLookup, this.animationLookup, this.data.setupData, false);
        // since the base track isnt going to have the changeDirection call triggered or anything we explicitly apply the current direction setup frames.
        if (this.data.setupData) {
            if (this.data.setupData.addedBoneIds) {
                for (let i = 0; i < this.data.setupData.addedBoneIds.length; i++) {
                    const id = this.data.setupData.addedBoneIds[i];
                    this.bones[id] = new Bone_1.Bone(id, this);
                    this.addChild(this.bones[id]);
                }
                // @ts-ignore
            }
            this.baseTrack.applySetupData(this.data.setupData, true);
        }
        this.highestTrack = this.baseTrack;
        this.attachmentAnimationLookups = baseSkeletonData.attachmentAnimations;
    }
    clone() {
        return new Skeleton(this.data, this.atlasLoader, Object.assign({}, this.activeSlotTextures));
    }
    getAllSlotCollidersWithTag(tag) {
        const array = [];
        for (let bone in this.bones) {
            const boneSlotColliders = this.bones[bone].slotColliderDatas;
            if (boneSlotColliders) {
                array.push(...boneSlotColliders.filter(c => { var _a; return (_a = c.tags) === null || _a === void 0 ? void 0 : _a.includes(tag); }));
            }
        }
        return array;
    }
    getFirstSlotColliderWithTag(tag) {
        var _a;
        for (let bone in this.bones) {
            const found = (_a = this.bones[bone].slotColliderDatas) === null || _a === void 0 ? void 0 : _a.find(b => { var _a; return (_a = b.tags) === null || _a === void 0 ? void 0 : _a.includes(tag); });
            if (found) {
                const newShapeData = this.bones[bone].applyTransformToCollider(found.shapeData);
                return Object.assign(Object.assign({}, found), { shapeData: newShapeData });
            }
        }
        return null;
    }
    stop() {
        this.stopped = true;
        this.baseTrack.stop();
        if (this.data.setupData) {
            this.baseTrack.applySetupData(this.data.setupData, true);
        }
    }
    play(actionName, direction, playOptions) {
        this.stopped = false;
        playOptions = playOptions || AnimationTrack_1.defaultPlayOptions;
        if (direction && direction !== this._direction) {
            this.direction = direction;
        }
        this.currentPlayOpts = playOptions;
        if (this.action) {
            this.removeChildPassiveTracks(this.action);
        }
        this.action = actionName;
        this.baseTrack.play(actionName, playOptions);
        this.addNeededChildPassiveTracks(actionName, this.activeAttachmentTracks, playOptions);
    }
    updateHighestTrack() {
        let highest = this.baseTrack;
        if (this.activeAttachmentTracks) {
            this.activeAttachmentTracks.forEach(t => {
                if (t.level > highest.level) {
                    highest = t;
                }
            });
        }
        if (highest !== this.highestTrack) {
            this.highestTrack = highest;
            highest.applyLastBoneOrder();
        }
    }
    update(delta) {
        this.colliderUpdates.length = 0;
        if (this.stopped)
            return;
        this.baseTrack.update(delta);
        if (this.activeAttachmentTracks) {
            for (let i = 0; i < this.activeAttachmentTracks.length; i++) {
                this.activeAttachmentTracks[i].update(delta);
            }
        }
    }
    getCollider(id) {
        return null;
    }
    setSkin(skin, updateBones = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let slots;
            if (skin.skinTexture) {
                slots = this.atlasLoader.getSlotsForTexture(skin.skinTexture, skin.atlasName);
            }
            else {
                slots = skin.skinUrl ?
                    yield this.atlasLoader.loadSkinSlotsByUrl(skin.atlasName, skin.skinUrl) :
                    yield this.atlasLoader.loadSkinSlots(skin.atlasName, skin.skinName);
            }
            this.skins[skin.atlasName] = skin.skinName ? skin.skinName : skin.skinUrl;
            for (let slot in slots) {
                this.activeSlotTextures[slot] = slots[slot];
            }
            //TODO: should only call update if the track utilizes bones that utilize the updated atlas name.
            let canSkipBonesAllTracks = {};
            if (updateBones) {
                for (let bone in this.bones) {
                    this.bones[bone].determineNewTrackOverride();
                }
                /*
                //console.error('UPDATING BONES!!!!!!!!!!!!');
                const walkFrameBones = (curFrameSkipMap, currentTrack, frameIndex) => {
                    const frameDatum = currentTrack.currentAnimation.frameData[frameIndex];
                    if(!frameDatum.bones) return;
                    for (let j = 0; j < frameDatum.bones.length; j++) {
                        const b = frameDatum.bones[j]
                        if(canSkipBonesAllTracks[b.id] || curFrameSkipMap[b.id]) continue;
                        if(this.bones[b.id].curTrackOverride !== currentTrack) {
                            curFrameSkipMap[b.id] = true;
                        }
                        if (b.slotId) {
                            this.bones[b.id].texture = this.activeSlotTextures[b.slotId];
                            canSkipBonesAllTracks[b.id] = true;
                        }
                    }
                }
                const walkTrackFrames = (t: AnimationTrack) => {
                    const skipBonesForCurrentTrack = {};
                    let i = t.currentFrame;
                    if(t.isReverse) {
                        while(i < t.currentAnimation.frameData.length) {
                            walkFrameBones(skipBonesForCurrentTrack, t, i)
                            i++;
                        }
                    } else {
                        while(i >= 0) {
                            walkFrameBones(skipBonesForCurrentTrack, t, i)
                            i--;
                        }
                    }
                }
                walkTrackFrames(this.baseTrack);
                this.activeAttachmentTracks.forEach(walkTrackFrames);
    
                 */
            }
        });
    }
    setSkins(skins) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < skins.length; i++) {
                const param = skins[i];
                if (!param.atlasName)
                    continue;
                yield this.setSkin(param, false);
            }
            //TODO: should probably be smarter about needing to call this.
            for (let bone in this.bones) {
                this.bones[bone].determineNewTrackOverride();
            }
        });
    }
    unmountAttachment(attachmentSlotName) {
        const curActive = this.attachmentSlots[attachmentSlotName];
        if (!curActive)
            throw new Error(`Skeleton did not have any attachment in the slot: ${attachmentSlotName} mounted.`);
        if (curActive !== this.attachments[curActive.attachment])
            throw new Error(`Found mis match of expected attachment slot: ${attachmentSlotName} and attachment ${curActive.attachment}`);
        curActive.unmount();
        if (curActive === this.highestTrack) {
            this.updateHighestTrack();
        }
    }
    _removeAttachmentFromLookups(attachmentSlotName, attachmentName) {
        const curActive = this.attachmentSlots[attachmentSlotName];
        if (!curActive)
            throw new Error(`Skeleton did not have any attachment in the slot: ${attachmentSlotName} mounted.`);
        delete this.attachmentSlots[attachmentSlotName];
        if (curActive !== this.attachments[attachmentName])
            throw new Error(`Found mis match of expected attachment slot: ${attachmentSlotName} and attachment ${curActive.attachment}`);
        delete this.attachments[attachmentName];
        for (let i = 0; i < this.activeAttachmentTracks.length; i++) {
            if (this.activeAttachmentTracks[i] === curActive) {
                this.activeAttachmentTracks.splice(i, 1);
                break;
            }
        }
        if (curActive === this.highestTrack) {
            this.updateHighestTrack();
        }
    }
    /*
    public _resetBones(boneIds?: Array<number>) {
        if(boneIds) {

        } else {
            // children should always be bones.
            for(let i = 0; i < this.children.length; i++) {
                this.children[i].setTransform(0, 0, 1, 1, 0);
            }
            this.baseTrack._reapplyFramesToCurrent();
            for(let i = 0; i < this.activeAttachmentTracks.length; i++) {
                //TODO: can probably determine if the attachment is effected by whatever caused the reset and if so then only reapply the frames.
                this.activeAttachmentTracks[i]._reapplyFramesToCurrent();
            }
        }
    }

     */
    logBoneOrder() {
        // @ts-ignore
        //console.error('child:', Array.from(this.children).map(c => c.id));
    }
    mountAttachment(attachmentSlotName, attachmentName, action, playOptions) {
        const LOG = true;
        LOG && console.time(`mount ${attachmentSlotName}`);
        const attachmentSlotData = this.data.attachmentSlotData[attachmentSlotName];
        if (!(attachmentSlotData))
            throw new Error(`No slot with the name ${attachmentSlotName}`);
        const { level, attachmentData, parentAttachmentName } = attachmentSlotData;
        const nextAttachmentData = attachmentData[attachmentName];
        if (!(nextAttachmentData))
            throw new Error(`Attachment: ${attachmentName} is not a valid attachment for the slot ${attachmentSlotName}`);
        let parentTrack;
        // if the attachment slot we're trying to add has a parent attachment, we need to confirm that the attachment is currently active.
        if (parentAttachmentName) {
            parentTrack = this.attachments[parentAttachmentName];
            if (!parentTrack)
                throw new Error(`Can not fill the attachment slot ${attachmentSlotName} because it requires the attachment: ${parentAttachmentName} be activated.`);
        }
        else {
            parentTrack = this;
        }
        // the current slot is already mounted, so we can call the unmount function with the param true to prevent frame data cascading away any attachment slot setupData.
        const persistedTrack = this.attachmentSlots[attachmentSlotName];
        persistedTrack === null || persistedTrack === void 0 ? void 0 : persistedTrack.unmount(true);
        const newTrack = persistedTrack ? persistedTrack : new AnimationTrack_1.AnimationTrack(this, level, this.activeSlotTextures, this.bones, this.atlasLoader.slotIdToColliderLookup);
        newTrack._updateAttachmentData(this.attachmentAnimationLookups[attachmentName], nextAttachmentData, attachmentSlotData);
        if (!this.activeAttachmentTracks) {
            this.activeAttachmentTracks = [newTrack];
            this.highestTrack = newTrack;
        }
        else {
            this.activeAttachmentTracks.push(newTrack);
            if (newTrack.level > this.highestTrack.level) {
                this.highestTrack = newTrack;
            }
        }
        this.attachments[attachmentName] = newTrack;
        this.attachmentSlots[attachmentSlotName] = newTrack;
        // only need to remount if the newTrack was not the persisted track.
        (newTrack !== persistedTrack) && newTrack._mountToParent(parentTrack);
        if (action) {
            newTrack.play(action, playOptions);
        }
        LOG && console.timeEnd(`mount ${attachmentSlotName}`);
        this.action && this.addNeededChildPassiveTracks(this.action, [newTrack], this.currentPlayOpts);
        return newTrack;
    }
    reapplyBoneSortSetups(v) {
        const a1 = this.activeAttachmentTracks ? [...this.activeAttachmentTracks] : [];
        const trackArray = [this.baseTrack, ...a1.sort((t, t2) => t.level - t2.level)];
        trackArray.forEach(a => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            // @ts-ignore
            ((_b = (_a = a.setupData) === null || _a === void 0 ? void 0 : _a.attachmentSlot) === null || _b === void 0 ? void 0 : _b.boneOrder) && a.applyBoneSort(a.setupData.attachmentSlot.boneOrder, Array.from(this.children));
            // @ts-ignore
            const frames = (_d = (_c = a.setupData) === null || _c === void 0 ? void 0 : _c.attachmentSlot) === null || _d === void 0 ? void 0 : _d.frames;
            // @ts-ignore
            frames && frames[v] && frames[v].boneOrder && a.applyBoneSort(frames[v].boneOrder, Array.from(this.children));
            // @ts-ignore
            ((_f = (_e = a.setupData) === null || _e === void 0 ? void 0 : _e.attachment) === null || _f === void 0 ? void 0 : _f.boneOrder) && a.applyBoneSort(a.setupData.attachment.boneOrder, Array.from(this.children));
            // @ts-ignore
            const frames2 = (_h = (_g = a.setupData) === null || _g === void 0 ? void 0 : _g.attachment) === null || _h === void 0 ? void 0 : _h.frames;
            // @ts-ignore
            frames2 && frames2[v] && frames2[v].boneOrder && a.applyBoneSort(frames2[v].boneOrder, Array.from(this.children));
        });
    }
    set direction(v) {
        if (v != this._direction) {
            this._direction = v;
            this.baseTrack.changeDirection(v);
            if (this.activeAttachmentTracks) {
                for (let i = 0; i < this.activeAttachmentTracks.length; i++) {
                    this.activeAttachmentTracks[i].changeDirection(v);
                }
            }
            this.reapplyBoneSortSetups(v);
        }
        // @ts-ignore
    }
    get direction() { return this._direction; }
}
exports.Skeleton = Skeleton;
//# sourceMappingURL=module.js.map